import React from 'react';

import { ReactComponent as HeroImage } from '../../assets/watermelon-pack-illustration-07.svg';
// import NavLink from '../nav-link';
import FormButton from '../button-form';

const HomeHero = () => {
	return (
		<div className="container mx-auto flex lg:py-20 py-10 md:flex-row flex-col items-center px-16 ">
			<div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-rigth mb-16 md:mb-0 items-center">
				<h1 className="title-font sm:text-2xl text-2xl mb-4 font-medium text-gray-900">
					سامانه مدیریت تیم
					<br className="hidden lg:inline-block" />به شما کمک می کند در مسیر خود بمانید !
				</h1>
				<p className="mb-8 leading-relaxed text-justify">
					اگر مدیر یک بیزینس آنلاین ودارای یک تیم متوسط به بالا هستید و ما پارتنر ای تی شما هستیم همین الان به این پروژه بپیوندید و درخواست خودتان را ثبت کنید
				</p>
				<div className="flex items-center flex-wrap">
					<a href="https://client.bndbs.ir/">
						<FormButton>درخواست اشتراک سامانه</FormButton>
					</a>
				</div>
			</div>
			<div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
				<HeroImage className="object-cover object-center rounded" alt="hero" />
			</div>
		</div>
	);
};

export default HomeHero;
